import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { ChangeDetectorRef, Inject, Injectable, Injector } from "@angular/core";
import { catchError, finalize, Observable, switchMap, throwError } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../services/auth.service";
import { LoaderService } from "../services/loader.service";
@Injectable()
export class AppInterceptor implements HttpInterceptor {
requestCounter = 0;// for loader
constructor(@Inject(Injector) private injector: Injector, private authService: AuthService,public loader:LoaderService ) {
}
intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldExcludeFromLoader = this.shouldExcludeFromLoader(request);
    
    if (!shouldExcludeFromLoader) {
        this.requestCounter++;
        this.showLoader(request);
    }
    
    //  if (this.authService.getAuthToken()) {
      request=this.setHeaders(request);
    // }
    return next.handle(request)
    .pipe(finalize(
        () => {
            if (!shouldExcludeFromLoader) {
                this.requestCounter--;
                if (this.requestCounter == 0) {
                   this.hideLoader();
                }
            }
        }),
        catchError((error: HttpErrorResponse) => {
          // Permission denials (ABP AbpAuthorizationException) can come back as 401.
          // Refreshing the token / redirecting to login reloads the page even though
          // the user is still authenticated — only the specific permission is missing.
          if (this.isPermissionDeniedError(error)) {
            this.showApiMessage(error);
            return throwError(() => error);
          }
          if (error.status === 401 || error.status === 406) {
            return this.authService.refreshToken().pipe(
              switchMap((data: any) => {
                let authResult = data;
                localStorage.setItem('id_token', authResult.idToken);
                localStorage.setItem('id_token_claims_obj', JSON.stringify(authResult.idTokenClaims));

                return next.handle(this.setHeaders(request));
              }),
              catchError((error: HttpErrorResponse) => {
                this.authService.login();
                return throwError(error);
              }
            ));
          } else {
            return throwError(error);
          }
        }));
}
  isPermissionDeniedError(error: HttpErrorResponse): boolean {
    const abpError = error?.error?.error;
    const message = `${abpError?.message || error?.error?.message || ''} ${abpError?.details || ''}`;
    return (
      error.status === 403 ||
      message.includes('Required permissions are not granted') ||
      message.includes('AbpAuthorizationException') ||
      message.includes("don't have permission")
    );
  }

  // resolved lazily to avoid a cyclic dependency with the http stack
  private get toaster(): ToastrService {
    return this.injector.get(ToastrService);
  }

  // Shows the message the API returned for an unauthorized call instead of
  // reloading the application.
  showApiMessage(error: HttpErrorResponse) {
    let message = error?.error?.error?.message || error?.error?.message;

    if (!message && typeof error?.error === 'string') {
      message = error.error;
    }

    if (message && message.includes("Exception of type 'Abp.Authorization.AbpAuthorizationException' was thrown")) {
      message = "You don't have permission to perform this action.";
    }

    if (!message) {
      message = error?.statusText || 'You are not authorized to perform this action.';
    }

    // AppErrorHandler also toasts unhandled http errors - flag this one so the
    // same message is not shown twice
    (error as any).isMessageShown = true;
    this.toaster.error(message);
  }

  shouldExcludeFromLoader(req:HttpRequest<any>): boolean {
    const url = req.url.toLowerCase();
    return (
        req.headers.has('noloader') ||
        url.includes("/connect/token") ||
        url.includes("getstatus") ||
        url.includes("/chat") ||
        url.includes("idpsessiondetailses/getall") ||
        url.includes("caseassistant/getactivecaseassistant") ||
        url.includes("caseassistantmessages/getall") ||
        url.includes("casetypeassistant/getall") ||
        url.includes("getallbycaseandassistant") ||
        url.includes("caseassistantmessages/getcaseassistantmessages") ||
        url.includes("documentchatquestions/getallbyknowledgebase")
    );
  }

  showLoader(req:HttpRequest<any>)
  {
    if (!this.shouldExcludeFromLoader(req)) {
        this.loader.show();
    }
  }
  hideLoader()
  {
    this.loader.hide();
  }
  setHeaders(request:HttpRequest<any>)
  {
    // Check if this is a BusinessCenter API call
    const isBusinessCenterApi = request.url.includes('BusinessCenter');
    
    if(this.authService.loggedInUser?.activeTenantKey==undefined)
    {
        request = request.clone({
            setHeaders: {
              'Authorization': `Bearer ${localStorage.getItem('id_token')}`,
          }
         });
    }
    else{
        const headers: any = {
          'Authorization': `Bearer ${localStorage.getItem('id_token')}`
        };
        
        // For BusinessCenter APIs, use organizationId instead of tenantkey
        if (isBusinessCenterApi) {
          const organizationId = localStorage.getItem('organizationId') || '';
          if (organizationId) {
            headers['organizationId'] = organizationId;
          }
        } else {
          // For other APIs, use tenantkey
          headers['tenantkey'] = `${this.authService.loggedInUser?.activeTenantKey}`;
        }
        
        request = request.clone({
            setHeaders: headers
         });
    }
      return request;
    }
  }
